/**
 * WordPress dependencies
 */
import { observableMap } from '@wordpress/compose';
import { createContext } from '@wordpress/element';

/**
 * Internal dependencies
 */

const initialValue = {
  slots: observableMap(),
  fills: observableMap(),
  registerSlot: () => {},
  unregisterSlot: () => {},
  registerFill: () => {},
  unregisterFill: () => {},
  updateFill: () => {}
};
export const SlotFillContext = createContext(initialValue);
export default SlotFillContext;
//# sourceMappingURL=context.js.map